// extracted by mini-css-extract-plugin
export var container = "productRow-module--container--4598a";
export var image = "productRow-module--image--f5e32";
export var info = "productRow-module--info--e73d7";
export var price = "productRow-module--price--29820";
export var quantityBtn = "productRow-module--quantityBtn--6ca81";
export var quantityContainer = "productRow-module--quantityContainer--7a637";
export var quantityLabel = "productRow-module--quantityLabel--8fdb5";
export var remove = "productRow-module--remove--1ea8b";
export var title = "productRow-module--title--a5077";